import React, {useEffect} from 'react'
import {Line} from "react-konva";
import _ from "lodash";

const BLOCK_SNAP_SIZE = 100;
const GRID_LINE_COLOR = '#64748b';
const CENTER_GRID_LINE_COLOR = 'red';
const OUTER_GRID_LINE_COLOR = 'green';
const INNER_GRID_LINE_COLOR = 'blue';
const INNER_2_GRID_LINE_COLOR = 'gray';

function prepareHighlightLineNumbers(totalLines) {
    const lineNumberDetail = {};

    lineNumberDetail[Math.round((totalLines * (1 / 2)))] = {color: CENTER_GRID_LINE_COLOR, width: 10};
    /*lineNumberDetail[Math.round((totalLines * (1 / 3)))] = {color: INNER_2_GRID_LINE_COLOR, width: 8};*/
    /*lineNumberDetail[Math.round((totalLines * (1 / 4)))] = {color: INNER_GRID_LINE_COLOR, width: 5};
    lineNumberDetail[Math.round((totalLines * (3 / 4)))] = {color: INNER_GRID_LINE_COLOR, width: 5};*/
    /*lineNumberDetail[Math.round((totalLines * (2 / 3)))] = {color: INNER_2_GRID_LINE_COLOR, width: 8};*/
    lineNumberDetail[Math.round((totalLines * (1 / 10)))] = {color: OUTER_GRID_LINE_COLOR, width: 5};
    lineNumberDetail[Math.round((totalLines * (2 / 10)))] = {color: INNER_2_GRID_LINE_COLOR, width: 8};
    lineNumberDetail[Math.round((totalLines * (3 / 10)))] = {color: INNER_GRID_LINE_COLOR, width: 5};
    lineNumberDetail[Math.round((totalLines * (4 / 10)))] = {color: OUTER_GRID_LINE_COLOR, width: 5};
    lineNumberDetail[Math.round((totalLines * (6 / 10)))] = {color: OUTER_GRID_LINE_COLOR, width: 5};
    lineNumberDetail[Math.round((totalLines * (7 / 10)))] = {color: INNER_GRID_LINE_COLOR, width: 5};
    lineNumberDetail[Math.round((totalLines * (8 / 10)))] = {color: INNER_2_GRID_LINE_COLOR, width: 8};
    lineNumberDetail[Math.round((totalLines * (9 / 10)))] = {color: OUTER_GRID_LINE_COLOR, width: 5};

    return lineNumberDetail;
}

function generateGridLineX(stageWidth, stageHeight) {
    const padding = BLOCK_SNAP_SIZE;
    const gridLines = [];
    const totalLines = stageWidth / padding;
    const highlightLineNumberDetail = prepareHighlightLineNumbers(totalLines);
    const highlightLineNumbers = _.keys(highlightLineNumberDetail);

    for (let i = 0; i < totalLines; i++) {
        gridLines.push({
            points: [Math.round(i * padding) + 0.5, 0, Math.round(i * padding) + 0.5, stageHeight],
            stroke: (_.indexOf(highlightLineNumbers, String(i)) !== -1) ? highlightLineNumberDetail[i]?.color : GRID_LINE_COLOR,
            strokeWidth: (_.indexOf(highlightLineNumbers, String(i)) !== -1) ? highlightLineNumberDetail[i]?.width : 0.5,
        });
    }

    return gridLines;
}

function generateGridLinesY(stageWidth, stageHeight) {
    const padding = BLOCK_SNAP_SIZE;
    const gridLinesY = [];
    const totalLines = stageHeight / padding;
    const highlightLineNumberDetail = prepareHighlightLineNumbers(totalLines);
    const highlightLineNumbers = _.keys(highlightLineNumberDetail);

    for (let j = 0; j < totalLines; j++) {
        gridLinesY.push({
            points: [0, Math.round(j * padding), stageWidth, Math.round(j * padding)],
            stroke: (_.indexOf(highlightLineNumbers, String(j)) !== -1) ? highlightLineNumberDetail[j]?.color : GRID_LINE_COLOR,
            strokeWidth: (_.indexOf(highlightLineNumbers, String(j)) !== -1) ? highlightLineNumberDetail[j]?.width : 0.5,
        });
    }

    return gridLinesY;
}

const GridLayer = ({stageWidth, stageHeight}) => {
    const [gridLines, setGridLines] = React.useState(generateGridLineX(stageWidth, stageHeight));
    const [gridLinesY, setGridLinesY] = React.useState(generateGridLinesY(stageWidth, stageHeight));

    useEffect(() => {
        if (stageWidth && stageHeight) {
            setGridLines(generateGridLineX(stageWidth, stageHeight))
            setGridLinesY(generateGridLinesY(stageWidth, stageHeight))
        }
    }, [stageWidth, stageHeight]);

    return (
        <>

            {gridLines.map((gridLine, i) => {
                return (
                    <Line
                        key={i}
                        {...gridLine}
                    />
                )
            })}
            <Line points={[0, 0, 10, 10]}/>
            {gridLinesY.map((gridLine, i) => {
                return (
                    <Line
                        key={i}
                        {...gridLine}
                    />
                )
            })}

        </>
    )
}

export default GridLayer
